import React from 'react';
import moment from "moment";

const numberCorrection = {
  "0": 0,
  "1": 5,
  "2": 4,
  "3": 3,
  "4": 2,
  "5": 1,
};

const useTextCorrection = () => {

  const filterNumber = (number) => {
    if(typeof number === "number") return (numberCorrection as any)[number.toString()];
    if(typeof number === "string") return (numberCorrection as any)[parseInt(number.split(' ')[0])]
    if(number === "" || number === undefined) return 0;
  };

  const replaceBreaks = (text) => {
    let elements = [];
    text.split('&lt;BR&gt;').map((item, index) => {
      elements.push(<p>{filterText(item)}</p>)
    });
    return elements;
  };

  const filterText = (text: string) => {
    if(typeof text != "string") return text;
    return text.replace(/&amp;/g,"&").replace(/&lt;BR&gt;/g,"\n");
  };

  const filterEmpty = (field) => {
    let element = field == ''? 'Not defined': field;
    element = filterText(element);
    return <td>{element}</td>
  };

  const fillSpacing = (text: string) => {
    let newText = text;
    if(text.length < 10); {
      for(let i =0; i<(10-text.length); i++) {
        newText = " ".concat(newText);
      }
    }
    return newText;
  };

  const correctDateFormat = (date: string, header: string) => {
    if(!header.toLowerCase().includes('date')) return date;
    if(date == '00:00:00 ') return 'Date not populated';
    let originalFormat = 'YYYY-MM-DD';
    let format = 'DD-MM-YYYY';

    if(header.toLowerCase().includes('routine')) {
      originalFormat = 'YYYY-MM';
      format = 'MM-YYYY'
    } else if(header.toLowerCase().includes('sla')) {
      originalFormat = 'hh:mm:ss YYYY-MM-DD';
      format = 'hh:mm:ss DD-MM-YYYY'
    }

    return moment(date, originalFormat).format(format);
  };

  return {
    filterNumber,
    filterText,
    filterEmpty,
    replaceBreaks,
    fillSpacing,
    correctDateFormat,
  }
};

export default useTextCorrection
